// extracted by mini-css-extract-plugin
export default {"flowContainer":"styles_flowContainer__g4g7r"};